import { createActionCreator } from '../utils/helpers';

import {
  removeDocument,
  uploadDocuments,
  updateProfileSection,
  fundingSearchProfile,
  needUpdateProfileSection,
  markProfileSectionAsComplete,
  REQUEST_AUTO_SAVE_PROFILE_SECTION,
  serviceabilityScore,
  serviceabilityPriceEstimates,
  SET_SNAPSHOT_CREATING,
} from './types';

export const requestFundingSearchProfile = createActionCreator(
  fundingSearchProfile.request,
  'fundingSearchId',
);
export const requestFundingSearchProfileSuccess = createActionCreator(
  fundingSearchProfile.success,
  'fundingSearchId',
  'response',
);
export const requestFundingSearchProfileFailure = createActionCreator(
  fundingSearchProfile.failure,
  'fundingSearchId',
  'error',
);

export const requestUpdateProfileSection = createActionCreator(
  updateProfileSection.request,
  'fundingSearchId',
  'sectionId',
  'payload',
  'promise',
);
export const requestUpdateProfileSectionSuccess = createActionCreator(
  updateProfileSection.success,
  'fundingSearchId',
  'sectionId',
  'response',
);
export const requestUpdateProfileSectionFailure = createActionCreator(
  updateProfileSection.failure,
  'fundingSearchId',
  'sectionId',
  'error',
);

export const requestMarkProfileSectionAsComplete = createActionCreator(
  markProfileSectionAsComplete.request,
  'fundingSearchId',
  'sectionId',
  'payload',
  'promise',
);

export const requestAutoSaveProfileSection = createActionCreator(
  REQUEST_AUTO_SAVE_PROFILE_SECTION,
  'fundingSearchId',
  'sectionId',
  'payload',
  'promise',
);

export const requestUploadDocuments = createActionCreator(
  uploadDocuments.request,
  'identifier',
  'fundingSearchId',
  'documentType',
  'files',
);
export const requestUploadDocumentsSuccess = createActionCreator(
  uploadDocuments.success,
  'fundingSearchId',
  'documentType',
  'documents',
);

export const requestRemoveDocument = createActionCreator(
  removeDocument.request,
  'fundingSearchId',
  'documentId',
  'documentType',
);
export const requestRemoveDocumentSuccess = createActionCreator(
  removeDocument.success,
  'fundingSearchId',
  'documentId',
  'documentType',
);

export const requestNeedUpdateProfileSection = createActionCreator(
  needUpdateProfileSection.request,
  'fundingSearchId',
  'sectionId',
  'promise',
);
export const requestNeedUpdateProfileSectionSuccess = createActionCreator(
  needUpdateProfileSection.success,
  'fundingSearchId',
  'sectionId',
  'response',
);
export const requestNeedUpdateProfileSectionFailure = createActionCreator(
  needUpdateProfileSection.failure,
  'fundingSearchId',
  'sectionId',
  'error',
);

export const requestServiceabilityScore = createActionCreator(
  serviceabilityScore.request,
  'sectionId',
  'payload',
);
export const requestServiceabilityScoreSuccess = createActionCreator(
  serviceabilityScore.success,
  'sectionId',
  'response',
);
export const requestServiceabilityScoreFailure = createActionCreator(
  serviceabilityScore.failure,
  'sectionId',
  'error',
);

export const requestServiceabilityPriceEstimates = createActionCreator(
  serviceabilityPriceEstimates.request,
  'fundingSearchId',
  'sectionId',
);
export const requestServiceabilityPriceEstimatesSuccess = createActionCreator(
  serviceabilityPriceEstimates.success,
  'sectionId',
  'response',
);
export const requestServiceabilityPriceEstimatesFailure = createActionCreator(
  serviceabilityPriceEstimates.failure,
  'sectionId',
  'error',
);

export const setSnapshotCreating = (isLoading) => ({
  type: SET_SNAPSHOT_CREATING,
  isLoading,
});
